import { useState } from "react";

import { Popper, Paper, ClickAwayListener } from "@mui/material";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";

import { MenuItem, MenuList } from "components/common/Menu";
import { hasPermission } from "hooks/usePermission";
import "./UpdateMenu.scss";

function UpdateMenu({
  isAch = false,
  onUpdateClick,
  onChangePaymentMethodClick,
  creditAllowed = false,
  isManual = false,
  onChangeToAchClick,
  onChangeToCardClick,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const canManageMethod = hasPermission("payments.manage_method");

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className="update-menu-icon-wrapper">
      <MoreVertOutlinedIcon className="update-menu-icon" onClick={handleClick} />
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-end"
        disablePortal={false}
        modifiers={[
          {
            name: "flip",
            enabled: true,
            options: {
              altBoundary: true,
              rootBoundary: "viewport",
              padding: 8,
            },
          },
        ]}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper
            sx={{
              boxShadow: "0px 8px 12px 0px var(--color-elevation-default, rgba(0, 0, 0, 0.16)) !important",
            }}
            className="update-menu-paper-style"
          >
            <MenuList autoWidth>
              {/* Manual (wire/cheque) card: only offer switching onto a real
                  method — there is no inline form to "Update", so that item is
                  omitted here. */}
              {isManual && canManageMethod && (
                <MenuItem
                  key="manual-change-ach"
                  value="Change to ACH"
                  isDense
                  className="menu-para-body-l-regular"
                  onClick={() => {
                    if (onChangeToAchClick) {
                      onChangeToAchClick();
                    }
                    handleClose();
                  }}
                />
              )}
              {isManual && canManageMethod && creditAllowed && (
                <MenuItem
                  key="manual-change-card"
                  value="Change to Credit/Debit Card"
                  isDense
                  className="menu-para-body-l-regular"
                  onClick={() => {
                    if (onChangeToCardClick) {
                      onChangeToCardClick();
                    }
                    handleClose();
                  }}
                />
              )}
              {!isManual && canManageMethod && (
                <MenuItem
                  key="update"
                  value="Update"
                  isDense
                  className="menu-para-body-l-regular"
                  onClick={() => {
                    if (onUpdateClick) {
                      onUpdateClick();
                    }
                    handleClose();
                  }}
                />
              )}
              {!isManual && canManageMethod && isAch && creditAllowed && (
                <MenuItem
                  key="change"
                  value="Change to Credit/Debit Card"
                  isDense
                  className="menu-para-body-l-regular"
                  onClick={() => {
                    if (onChangePaymentMethodClick) {
                      onChangePaymentMethodClick();
                    }
                    handleClose();
                  }}
                />
              )}
              {!isManual && canManageMethod && !isAch && (
                <MenuItem
                  key="change"
                  value="Change to ACH"
                  isDense
                  className="menu-para-body-l-regular"
                  onClick={() => {
                    if (onChangePaymentMethodClick) {
                      onChangePaymentMethodClick();
                    }
                    handleClose();
                  }}
                />
              )}
            </MenuList>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  );
}

export default UpdateMenu;
